import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import PARCEL_STAGE from '@pperform/pp-constants/parcelStage.constants';
import { checkHasCustomsStage } from '@pperform/pp-utils/parcelOrg';
import { hideCustomsPhaseForEUROPEShipment } from '@pperform/pp-utils/event.utils';
import { useProgressForwardSteps } from '@pperform/pp-react-components/PpProgressIndicatorForward';

import { constructForwardProgressIndicatorTheme } from 'utils/progressIndicator.utils';
import type Shipment from 'interfaces/PmParcel';
import type { PpProgressIndicator } from '../models';

export const useProgressForwardShipment = (baseShipment: Shipment) => {
  const { t } = useTranslation();
  const configs = usePTPConfigContext();

  const { isHideCustomsPhase: isHideCustomsPhaseConfig } =
    configs.progressBarBox;
  const { events, issueState } = baseShipment;

  const hasCustomsStage = baseShipment && checkHasCustomsStage(baseShipment);
  const isHideCustomsPhase =
    isHideCustomsPhaseConfig || hideCustomsPhaseForEUROPEShipment(baseShipment);
  const progressItemThemes = constructForwardProgressIndicatorTheme(configs);

  // Get eventsTypeMasterData array and remove item without stageKey
  const eventsTypeMasterData = events
    ?.map((item) => item?.eventTypeMasterData)
    ?.filter((item) => item?.stageKey);

  // Get stage from newest event
  const stage = eventsTypeMasterData?.[0]?.stageKey || PARCEL_STAGE.pickup;

  const progressIndicator: PpProgressIndicator = useProgressForwardSteps({
    stage,
    events: eventsTypeMasterData,
    progressItemThemes,
    hasCustomsStage,
    isHideCustomsPhase,
    issueState,
    translation: t,
  });

  const { steps, activeStageIndex, theme } = progressIndicator;

  const activeStage = steps[activeStageIndex] || {};
  const iconTheme = theme.current;

  return {
    steps,
    activeStage,
    activeStageIndex,
    iconTheme,
  };
};
